module.exports = __webpack_public_path__ + "static/media/margaret-hamilto.964d1b96.jpg";